export const QUERY_ENTRY_SEPARATOR = '@@SEP@@'; // sentinel string that is unlikely to appear in user‑supplied data
export const QUERY_FIELDS_SEPARATOR = ',';
export const QUERY_FIELDS_ALL = 'all';
export const ENCODED_COMMAS = /%2C/gi;
export const URL_QUERY_PARAM = 'q';
export const URL_SORT_PARAM = 's';
export const URL_FILTER_PARAM = 'f';
export const URL_PAGE_PARAM = 'p';
export const URL_TAB_PARAM = 't';
export const URL_FIELDS_PARAM = 'fs';
export const URL_RF_PARAM = 'rf';
